module.exports = __webpack_public_path__ + "img/cz.1c39312e.svg";